var _circle, _rect, _rect2, _g, _path, _path2, _path3, _path4, _rect3, _path5, _path6, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueReportWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ContactUS_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 0.436,
    cy: 0.436,
    r: 0.436,
    transform: "translate(11.883 1.284)",
    fill: "#787f88"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1198",
    "data-name": "Rectangle 1198",
    width: 18,
    height: 18,
    fill: "none",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 17,
    height: 17,
    transform: "translate(1 1)",
    fill: "#ffecd4",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3291",
    "data-name": "Group 3291",
    transform: "translate(6.381 6.404)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 0.718,
    cy: 0.718,
    r: 0.718,
    transform: "translate(4.302)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 0.718,
    cy: 0.718,
    r: 0.718,
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M11.324,13.926A3.055,3.055,0,0,1,8.879,12.7a.361.361,0,1,1,.581-.428,2.331,2.331,0,0,0,3.729,0,.361.361,0,1,1,.581.428,3.044,3.044,0,0,1-2.445,1.223Z",
    transform: "translate(-8.458 -9.264)",
    fill: "#787f88"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M6.4,19.684a.446.446,0,0,0,.772.306l2.675-2.873a.448.448,0,0,0,0-.611l-.107-.115H6.4Z",
    transform: "translate(-1.509 -3.865)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M20.549,13.85v2.759a2.528,2.528,0,0,1-2.529,2.529",
    transform: "translate(-4.249 -3.266)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M17.64,2.25h.29A2.528,2.528,0,0,1,20.46,4.779V6.843",
    transform: "translate(-4.16 -0.531)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M3.31,6.934V4.779A2.528,2.528,0,0,1,5.839,2.25h5.938",
    transform: "translate(-0.781 -0.531)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.06
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 4.127,
    height: 2.468,
    rx: 1.234,
    transform: "translate(9.675 14.581)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M2.422,8.25H4.187v4.188H2.422a.77.77,0,0,1-.772-.772V9.022a.77.77,0,0,1,.772-.772Z",
    transform: "translate(-0.389 -1.946)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M.772,0H2.537V4.188H.772A.77.77,0,0,1,0,3.416V.772A.77.77,0,0,1,.772,0Z",
    transform: "translate(17.332 10.5) rotate(180)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 10.997,
    height: 8.253,
    rx: 0.65,
    transform: "translate(3.798 4.279)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueReportWhiteIcon);
export default __webpack_public_path__ + "static/media/issue-report-white-icon.24ac3f2023d6bd61f824c0d1b96e118d.svg";
export { ForwardRef as ReactComponent };